import { jsx as _jsx } from "react/jsx-runtime";
import { ThemeMode } from '@libs/theme';
import { useTheme } from 'styled-components';
import Tabs from '../tabs/Tabs';
import { CustomMoonIcon, CustomSunIcon, IconWrapper } from './styles';
const LIGHT_THEME_ID = 1;
const DARK_THEME_ID = 2;
const ThemeToggler = ({ onThemeToggle, activeTheme, }) => {
    const { colors } = useTheme();
    const activeColor = colors.text.default;
    const passiveColor = colors.text.secondary;
    const tabsObject = {
        [`${LIGHT_THEME_ID}`]: {
            id: LIGHT_THEME_ID,
            title: '',
            component: (_jsx(IconWrapper, { children: _jsx(CustomSunIcon, { color: activeTheme === ThemeMode.light ? activeColor : passiveColor }) })),
            theme: ThemeMode.light,
        },
        [`${DARK_THEME_ID}`]: {
            id: DARK_THEME_ID,
            title: '',
            component: (_jsx(IconWrapper, { children: _jsx(CustomMoonIcon, { color: activeTheme === ThemeMode.dark ? activeColor : passiveColor }) })),
            theme: ThemeMode.dark,
        },
    };
    const handleTabClick = (id) => {
        const selectedTheme = tabsObject[id].theme;
        onThemeToggle(selectedTheme);
    };
    // transforming tabs object into an array which is accepted by Tabs component
    const tabs = Object.values(tabsObject);
    const activeTab = tabs.find((tab) => tab.theme === activeTheme);
    return (_jsx(Tabs, { activeTab: activeTab?.id || LIGHT_THEME_ID, handleTabClick: handleTabClick, tabs: tabs }));
};
export default ThemeToggler;
//# sourceMappingURL=ThemeToggler.js.map